import React, { useMemo, useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { StyledButtonLink } from '../components/styled';
import { useRequestMeMutation } from 'src/modules/shared/slices/auth/entity/api/auth';
import {
  useAnswerdExternalSurveyMutation,
  usePostponeSurveyMutation,
  useRefusingSurveyMutation,
  useSaveSurveyMutation,
} from 'src/modules/shared/slices/survey/surveyApi';

const thankYouText = {
  title: 'Bedankt. Vertel ons meer en ontvang een cadeau.',
  description: 'Jouw feedback helpt ons groeien! De vragenlijst duurt maximaal 10 minuten.',
  button: {
    text: 'Geef nu feedback',
    link: `link`,
  },
  leftLink: 'Herinner me er later aan',
  rightLink: `Nooit`,
};

const reminder = {
  title: 'Hier is de herinnering voor het geven van feedback.',
  description:
    'We weten dat je tijd waardevol is, daarom verloten wij geschenken onder de deelnemers van onze enquête!',
  button: {
    text: 'Ik neem nu 15 minuten',
    link: `link`,
  },
  leftLink: 'Herinner me er later aan',
  rightLink: `Nooit`,
};

const SurveyConfirmation = () => {
  const [showConfirmationModal, setShowconfirmationModal] = useState(false);
  const [, { data: meResponse, reset: resetMe }] = useRequestMeMutation({
    fixedCacheKey: '/me',
  });
  const [, result] = useSaveSurveyMutation({ fixedCacheKey: 'survey' });
  const [refuseSurvey, refuseResponse] = useRefusingSurveyMutation();
  const [postponeSurvey, postponeResponse] = usePostponeSurveyMutation();
  const [answerdExternalSurvey, answerdExternalResponse] = useAnswerdExternalSurveyMutation();

  useEffect(() => {
    if (showConfirmationModal) return;
    if (result.isUninitialized) return;
    if (!result.isUninitialized) {
      setShowconfirmationModal(true);
      result.reset();
    }
  }, [result, result.isUninitialized, showConfirmationModal]);

  useEffect(() => {
    if (showConfirmationModal) return;
    if (meResponse?.survey?.isAnswered && meResponse.survey.externalSurvey) {
      setShowconfirmationModal(true);
    }
  }, [meResponse, showConfirmationModal]);

  const handleCloseModal = () => {
    setShowconfirmationModal(false);
  };

  const handleRefuse = () => {
    if (!meResponse?.survey?.key) return;
    refuseSurvey({ key: meResponse?.survey?.key });
    handleCloseModal();
  };

  const handlePostPone = () => {
    if (!meResponse?.survey?.key) return;
    postponeSurvey({ key: meResponse?.survey?.key });
    handleCloseModal();
  };

  const handleClickExternalSurvey = () => {
    if (meResponse?.survey?.externalSurvey && meResponse?.survey?.key) {
      window.open(meResponse?.survey?.externalSurvey, '_blank');
      answerdExternalSurvey({ key: meResponse?.survey.key });
    }
    handleCloseModal();
  };

  const text = useMemo(() => {
    if (meResponse?.survey?.isAnswered) {
      return reminder;
    }
    return thankYouText;
  }, [meResponse?.survey?.isAnswered]);

  useEffect(() => {
    if (
      refuseResponse.isSuccess ||
      postponeResponse.isSuccess ||
      answerdExternalResponse.isSuccess
    ) {
      resetMe();
      handleCloseModal();
    }
  }, [
    answerdExternalResponse.isSuccess,
    postponeResponse.isSuccess,
    refuseResponse.isSuccess,
    resetMe,
  ]);

  if (!meResponse?.survey?.externalSurvey) return null;

  return (
    <>
      <Dialog open={showConfirmationModal}>
        <DialogTitle>
          <Typography variant="h3">{text.title}</Typography>
        </DialogTitle>
        <DialogContent style={{ gap: 24, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body2" style={{ fontSize: '14px', lineHeight: '16.8px' }}>
            {text.description}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            style={{ textTransform: 'none', width: 'fit-content' }}
            onClick={() => handleClickExternalSurvey()}
          >
            {text.button.text}
          </Button>
        </DialogContent>

        <DialogActions style={{ padding: '8px 16px', justifyContent: 'space-between' }}>
          <StyledButtonLink variant="text" onClick={() => handlePostPone()}>
            {text.leftLink}
          </StyledButtonLink>
          <StyledButtonLink variant="text" onClick={() => handleRefuse()}>
            {text.rightLink}
          </StyledButtonLink>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SurveyConfirmation;
